var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 
  'c-text-box-element', 
  _vm.content.properties[0] ? ("c-text-box-element--" + (_vm.content.properties[0].value.toLowerCase())) : '',
  _vm.content.properties[1] ? ("c-text-box-element--" + (_vm.content.properties[1].value.toLowerCase())) : '' 
]},[_c('div',{directives:[{name:"md-html",rawName:"v-md-html",value:(_vm.content.content),expression:"content.content"}],staticClass:"c-article__section-text"})])}
var staticRenderFns = []

export { render, staticRenderFns }